/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { TestQConfig } from '../../../../model/testQConfig';
import { TestQType, TestTypeEnum } from '../../../../model/testQType';
import { TestQTypeService } from '../../../../services/testQType.service';
import { Subject, takeUntil } from 'rxjs';
import { TestQElementTypeService } from '../../../../services/testQElementType.service';
import { TestQElementType } from '../../../../model/testQElementType';
import { VerificationQTypeService } from '../../../../services/verificationQType.service';
import { VerificationQType } from '../../../../model/verificationQType';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ExpectedResultTypeService } from '../../../../services/expectedResultType.service';
import { ExpectedResultType } from 'src/app/model/expectedResultType';
import { ResultQTypeService } from '../../../../services/resultQType.service';
import { ResultQType } from '../../../../model/resultQType';
import { SnackBarService } from '../../../../services/snackBar.service';
import { TestQConfigService } from '../../../../services/testQConfig.service';
import { CustomDatepickerHeaderComponent } from '../../../shared/datepicker-custom-header/datepicker-custom-header.component';
import {
	ProtocolQTestGeneralData, ProtocolQTest,
	ProtocolQTestBioindicadores,
	ProtocolQTestData,
	ProtocolQTestDataOQ,
	ProtocolQTestItem,
	ProtocolQTestProbeTraceability,
	ProtocolQTestResults,
	ProtocolStatus,
	ProtocolQTestItemVerification,
	ProtocolQTestEssayGroup,
	ProtocolQ,
	ProtocolQTestItemGroup,
	ProtocolQTestInstrumentalUsed
} from '../../../../model/protocol';

import { TestQItemService } from '../../../../services/testQItem.service';
import { TestQItem } from '../../../../model/testQItem';
import { TranslateService } from '@ngx-translate/core';
import { TestGeneralDataConfig } from 'src/app/model/testGeneralDataConfig';
import { TestGeneralDataConfigService } from 'src/app/services/testGeneralDataConfig.service';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/services/user.service';
import { ReasonDialogComponent } from 'src/app/components/shared/reason-dialog/reason-dialog.component';

import { MatCheckboxChange } from '@angular/material/checkbox';
import * as _ from 'lodash';
import { DataResultResizeImage, ResizeImageComponent } from '../../../shared/resize-image/resize-image.component';
import { AttachmentQualificatesService } from '../../../../services/attachmentQualificates.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { FileInfo } from '../../../../model/attachment';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ProtocolEditTestAttachmentsComponent } from '../protocol-edit-test-attachments/protocol-q-edit-test-attachments.component';
import { EquipmentQualificates } from 'src/app/model/equipment';
import { EssayTypeEnum, EssayUtils } from '../../../../utils/essayUtils';
import { ProtocolQEditTestEssayComponent } from '../protocol-q-edit-test-essay/protocol-q-edit-test-essay.component';
import { ProtocolUtils } from '../../../../utils/protocolUtils';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { InstrumentationUse } from '../../../../model/instrumentationUse';
import { InstrumentationService } from '../../../../services/instrumentation.service';
import { v4 as uuid } from 'uuid';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { quillConfig } from '../../../../quill-config';

import Quill from 'quill';
import BlotFormatter2 from '@enzedonline/quill-blot-formatter2';
import { FileUtils } from '../../../../utils/fileUtils';
import { ProtocolQEditTestInstrumentalUsedComponent } from '../protocol-q-edit-test-instrumental-used/protocol-q-edit-test-instrumental-used.component';
import { VerificationProcessingTypeEnum } from 'src/app/model/testQDataVerification';
import { ArrayUtils } from '../../../../utils/arrayUtils';

Quill.register('modules/blotFormatter2', BlotFormatter2);

export class Group {
	level = 0;
	expanded = false;
	totalCounts = 0;
}

export interface DialogQEditTest {
	idItem: number;
	testQType: TestQType;
	reason: string;
	isEdit: boolean;
	isEditTest: boolean;
	data: ProtocolQTest;
	idStatus: number;
	numberTest: number;
	equipment: EquipmentQualificates[];
	idPhase: number;
	tests: ProtocolQTest[]
	nProtocol: string;
	protocol: ProtocolQ;
	position: number;
}

@Component({
    selector: 'app-protocol-q-edit-test',
    templateUrl: './protocol-q-edit-test.component.html',
    styleUrls: ['./protocol-q-edit-test.component.scss'],
    standalone: false,
})
export class ProtocolQEditTestComponent implements OnInit, AfterViewInit {

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild('tableTest', { static: true }) tableTest: MatTable<any>;
	@ViewChildren('attachmentsTestComponent') attachmentsComponent: ProtocolEditTestAttachmentsComponent;
	@ViewChild('essaysTable') essaysTable: MatTable<any>;
	@ViewChild('protocolQTestInstrumentalUsedT') protocolQTestInstrumentalUsedTable: MatTable<any>;
	@ViewChild('tabEssays', { static: true }) tabEssays: MatTabGroup;

	allData: any[];
	_allGroup: any[];
	dataSource: ProtocolQTest = new ProtocolQTest();

	displayedColumns: string[] = ['verificationTypeDesc'];
	columnsToDisplay: string[] = this.displayedColumns.slice();
	groupByColumns: string[] = [];
	essaysCols = ['order', 'essayType', 'variables', 'criteria', 'edit', 'delete'];
	displayedColsInstrumentalUsed: string[] = ['instrumental', 'edit', 'delete'];

	testConfig: TestQConfig = new TestQConfig();
	testQTypes: TestQType[];
	testQElementTypes: TestQElementType[];
	verificationQTypes: VerificationQType[];
	expectedResultTypes: ExpectedResultType[];
	resultQTypes: ResultQType[];
	columns: any[] = [];
	expandedCar: any[] = [];
	fileName: string | null = null;
	allowedDataIQ: number[] = [TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT, TestTypeEnum.VERIFICATION_COMPONENTS_EQUIPMENT_DIMENSIONS_MATERIALS, 
		TestTypeEnum.VERIFICATION_LOCATION_ASSOCIATED_SERVICES, TestTypeEnum.MATCHING_INSTALLATION_PLANS,  TestTypeEnum.EQUIPMENT_DOCUMENTATION_VERIFICATION,  TestTypeEnum.EQUIPMENT_VERIFICATION, 
		TestTypeEnum.VERIFICATION_APPROVAL_DESIGN_QUALIFICATION, TestTypeEnum.VERIFICATION_APPROVAL_PROTOCOL_QUALIFICATION];
	allowedDataOQ: number[] = [TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION, TestTypeEnum.VERIFICATION_CONTROL_PANEL, 
			TestTypeEnum.VERIFICATION_OF_EQUIPMENT_ALARMS_SAFEGUARDS, TestTypeEnum.VERIFICATION_OF_INTERLOCKS,  TestTypeEnum.TEST_TIGHTNESS_TEST_VACUUM_TEST_LEAK_TEST,  TestTypeEnum.LEAKAGE_TEST, 
			TestTypeEnum.TEST_BOWIE_DICK, TestTypeEnum.RELATIVE_MOISTURE_TEMPERATURE_DISTRIBUTION_TEST_CO2_IN_VACUUM];
	allowedEssay: number[] = [TestTypeEnum.RELATIVE_MOISTURE_TEMPERATURE_DISTRIBUTION_TEST_CO2_IN_VACUUM, TestTypeEnum.TEST_TIGHTNESS_TEST_VACUUM_TEST_LEAK_TEST,
		TestTypeEnum.TEMPERATURE_PENETRATION_TEST_UNDER_LOAD_TEMPERATURE, TestTypeEnum.TEST_TEMPERATURE_DISTRIBUTION_MOISTURE_CO2_WITH_LOAD_OPENING_DOORS, 
	]

	allowedEssayInstUsed: number[] = [TestTypeEnum.RELATIVE_MOISTURE_TEMPERATURE_DISTRIBUTION_TEST_CO2_IN_VACUUM, 
		TestTypeEnum.TEMPERATURE_PENETRATION_TEST_UNDER_LOAD_TEMPERATURE, TestTypeEnum.TEST_TEMPERATURE_DISTRIBUTION_MOISTURE_CO2_WITH_LOAD_OPENING_DOORS, 
	]
	
	currentUser: User;
	customDatepickerHeader = CustomDatepickerHeaderComponent;

	quillConfig = {
		toolbar: quillConfig.toolbar,
		blotFormatter2: quillConfig.blotFormatter2,
	};

	isTacometer: boolean;
	tacometer: string;
	dragDisabled = true;

	_groupItem = 0;
	showValidatorSpecifics = false;
	instrumentationUse: InstrumentationUse[] = [];
	
	criteriaTab = false;

	private destroy$ = new Subject<void>();

	constructor(private testQTypeService: TestQTypeService,
		private testQElementTypeService: TestQElementTypeService,
		private verificationQTypeService: VerificationQTypeService,
		private expectedResultTypeService: ExpectedResultTypeService,
		private resultQTypeService: ResultQTypeService,
		private snackBarService: SnackBarService,
		private testQConfigService: TestQConfigService,
		private testGeneralDataConfigService: TestGeneralDataConfigService,
		private testQItemService: TestQItemService,
		private dialogRef: MatDialogRef<ProtocolQEditTestComponent>,
		private translate: TranslateService,
		private userService: UserService,
		private attachmentService: AttachmentQualificatesService,
		private spinnerService: SpinnerService,
		public dialog: MatDialog,
		private cdr: ChangeDetectorRef,
		private instrumentationService: InstrumentationService,
		@Inject(MAT_DIALOG_DATA) public data: DialogQEditTest) {
		this.currentUser = this.userService.currentProfile;
	}

	ngAfterViewInit(): void {
		if (this.data.data.id != null) {
			if (this.attachmentsComponent instanceof QueryList) {
				this.attachmentsComponent = this.attachmentsComponent.first as ProtocolEditTestAttachmentsComponent;
			}
		}
	}

	onModelChange(content: string): string {
		let modifiedContent = content.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>');
		return modifiedContent;
	}

	ngOnInit(): void {
		if (!this.data.data.protocolQTestInstrumentalUsed) {
			this.data.data.protocolQTestInstrumentalUsed = [];
		}
		this.dataSource = this.data.data;
		
		if (this.data.data.idTestType !== TestTypeEnum.RELATIVE_MOISTURE_TEMPERATURE_DISTRIBUTION_TEST_CO2_IN_VACUUM) { 
			this.essaysCols.push('load');
		}
		
		if (this.allowedEssay.includes(this.data.testQType.id)) {
			if (!this.data.data.testDescription) {
				this.data.data.testDescription = this.translate.instant('testQualification.' + this.data.testQType.translation) as string;
			}
		} else {
			if (!this.data.data.testDescription) {
				this.data.data.testDescription = this.translate.instant('testQualification.' + this.data.testQType.translation) as string;
			}
		}

		this.testQTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((result: TestQType[]) => {
			this.testQTypes = result;
		});

		this.testQElementTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((result: TestQElementType[]) => {
			this.testQElementTypes = result;
		});

		this.verificationQTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((result: VerificationQType[]) => {
			this.verificationQTypes = result;
		});

		this.expectedResultTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((result: ExpectedResultType[]) => {
			this.expectedResultTypes = result;
		});

		this.resultQTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((result: ResultQType[]) => {
			this.resultQTypes = result;
		});

		this.instrumentationUse = [];
		this.instrumentationService.findAllProtocol().pipe(takeUntil(this.destroy$))
		  .subscribe((data: InstrumentationUse[]) => this.instrumentationUse = data);

		if (this.data.testQType) {
			this.testQConfigService.findByIdTest(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((result: TestQConfig) => {
				this.testConfig = result;
			});

			if (!this.allowedEssay.includes(this.data.testQType.id)) {
				if (!this.data.data.protocolQTestItemGroup) {
					let group = new ProtocolQTestItemGroup();
					group.idTestType = this.data.testQType.id;
					group.numCycle = 1;
					group.uuid = uuid();
					group.active = true;
					group.title = '-';
					this.testQItemService.findAllByIdTest(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((result: TestQItem[]) => {
						for (let index = 0; index < result?.length; index++) {
							const element = result[index];
							
							const protocolQTestItem = new ProtocolQTestItem();
							protocolQTestItem.description = element.description;
							protocolQTestItem.idType = element.idType;
							protocolQTestItem.protocolQTestItemVerification = [];
							element.testQItemVerifications?.forEach(rt => {
								const protocolQTestItemVerification = new ProtocolQTestItemVerification();
								if (this.data.testQType.id === TestTypeEnum.VERIFICATION_APPROVAL_PROTOCOL_QUALIFICATION) {
									if (rt.verification === 'PRIQOQPQQXXXX') {
										protocolQTestItemVerification.verification = this.data.nProtocol;
									} else {
										protocolQTestItemVerification.verification = rt.verification;
									}
								} else {
									protocolQTestItemVerification.verification = rt.verification;
								}
								protocolQTestItemVerification.processingType = rt.processingType;
								rt.testQDataMultiple.forEach(pte => {
									const protocolQTestData = new ProtocolQTestData();
									protocolQTestData.expectedResultRhDesc = pte.expectedResultRhDesc;
									protocolQTestData.onlyLine = pte.combined;
									if (this.data.testQType.id === TestTypeEnum.EQUIPMENT_VERIFICATION) {
										if (pte.expectedResultRhDesc) {
											protocolQTestData.expectedResultDesc =  ProtocolUtils.getEquipmentByField(pte.expectedResultRhDesc, this.data.equipment);
										}
									} else {
										protocolQTestData.expectedResultDesc = pte.expectedResultDesc;
									}
									protocolQTestData.resultDesc = pte.resultDesc;
									if (!protocolQTestItemVerification.protocolQTestDataMultiple) {
										protocolQTestItemVerification.protocolQTestDataMultiple = [];
									}
									protocolQTestItemVerification.protocolQTestDataMultiple.push(protocolQTestData);
								});
		
								protocolQTestItem.protocolQTestItemVerification.push(protocolQTestItemVerification);
							});
		
							if (!group.protocolQTestItems) {
								group.protocolQTestItems = [];
							}
							group.protocolQTestItems.push(protocolQTestItem);
						}
						if (!this.dataSource.protocolQTestItemGroup) {
							this.dataSource.protocolQTestItemGroup = [];
						}
						this.dataSource.protocolQTestItemGroup.push(group);
						this.onEssayTabChange(0);
					});

					this.testGeneralDataConfigService.getTestGeneralDataConfigById(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((result: TestGeneralDataConfig[]) => {
						result?.forEach(r => {
							this.dataSource.protocolQTestGeneralData = [];
							const protocolGeneral = new ProtocolQTestGeneralData();
							protocolGeneral.methodology = ProtocolUtils.remplaceVariableInText(this.data.protocol, r.methodology, this.translate);
							protocolGeneral.objective =  ProtocolUtils.remplaceVariableInText(this.data.protocol, r.objective, this.translate);
							protocolGeneral.criteria =   ProtocolUtils.remplaceVariableInText(this.data.protocol, r.criteria, this.translate);
							this.dataSource?.protocolQTestGeneralData.push(protocolGeneral)
						});
					});
				} else {
					if (this.dataSource.protocolQTestItemGroup) {
						if (this.dataSource.protocolQTestItemGroup.some(e => !e.position)) {
							this.dataSource.protocolQTestItemGroup.filter(pig => !pig.position).forEach((element, index) => {
								element.position = index + 1;
							});
						}
						this.dataSource.protocolQTestItemGroup = [...this.dataSource.protocolQTestItemGroup.filter(f => f.position).sort((a, b) => a.position - b.position)];	
					}

					if (this.dataSource.protocolQTestEssayGroup) {
						this.dataSource.protocolQTestEssayGroup = [...this.dataSource.protocolQTestEssayGroup.filter(f => f.position).sort((a, b) => a.position - b.position)];	
					}

					this.onEssayTabChange(0);
				}
			}
	
			if (this.data.tests) {
				if (this.data.data.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TEST_QUALIFICATION_PERFORMANCE_TESTING) {
					const dataOQ = this.data.tests.filter(e => this.allowedDataOQ.includes(e.idTestType) && this.isCompletedTest(e.idTestType));
					if (dataOQ){
						dataOQ.sort((a, b) => {
							return a.position - b.position;
						});

						for (let index = 0; index < dataOQ.length; index++) {
							const element = dataOQ[index];
							const protocolQTestOQ = new ProtocolQTestDataOQ();
							protocolQTestOQ.descriptionTest = element.testDescription;
							protocolQTestOQ.position = element.position;
							protocolQTestOQ.idTest = element.id;
							protocolQTestOQ.test = this.translate.instant('protocolEdit.test.data.iq.test', {nPrueba:  element.position});
							protocolQTestOQ.resultDesc = ['according','not_according', 'not_applicable'];
							protocolQTestOQ.idTestType = element.idTestType;
							if (!this.dataSource.protocolQTestVerification) {
								this.dataSource.protocolQTestVerification = [];
							}

							const exists = this.dataSource?.protocolQTestVerification.findIndex((test) => test.descriptionTest === element.testDescription);
							if (exists === -1) {
								this.dataSource?.protocolQTestVerification.push(protocolQTestOQ);
							} else {
								this.dataSource.protocolQTestVerification[exists] = protocolQTestOQ;
							}
						}
						this.dataSource?.protocolQTestVerification?.sort((a, b) =>  a.position - b.position);
					}
				} else if (this.data.data.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION) {
					const dataIQ = this.data.tests.filter(e => this.allowedDataIQ.includes(e.idTestType) && this.isCompletedTest(e.idTestType));
					if (dataIQ){
						dataIQ.sort((a, b) => {
							return a.position - b.position;
						});

						for (let index = 0; index < dataIQ.length; index++) {
							const element = dataIQ[index];
							const protocolQTestOQ = new ProtocolQTestDataOQ();
							protocolQTestOQ.descriptionTest = element.testDescription;
							protocolQTestOQ.position = element.position;
							protocolQTestOQ.test = this.translate.instant('protocolEdit.test.data.iq.test', {nPrueba: element.position});
							protocolQTestOQ.resultDesc = ['according','not_according', 'not_applicable'];

							if (!this.dataSource.protocolQTestVerification) {
								this.dataSource.protocolQTestVerification = [];
							}
							const exists = this.dataSource?.protocolQTestVerification.findIndex((test) => test.descriptionTest === element.testDescription);

							if (exists === -1) {
								this.dataSource?.protocolQTestVerification.push(protocolQTestOQ);
							} else {
								this.dataSource.protocolQTestVerification[exists] = protocolQTestOQ;
							}
						}
						this.dataSource?.protocolQTestVerification?.sort((a, b) =>  a.position - b.position);
					}
				}
			}
		}

		this.onChangeSelectionOption();
	}

	configTemplate(): void {
		this.data.data.testDescription = ProtocolUtils.getNameTestQualificates(this.data.data, this.translate);
		this.testGeneralDataConfigService.getTestGeneralDataConfigById(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((result: TestGeneralDataConfig[]) => {
			result?.forEach(r => {
				this.dataSource.protocolQTestGeneralData = [];
				const protocolGeneral = new ProtocolQTestGeneralData();
				protocolGeneral.methodology = ProtocolUtils.getMethodologyTestQualificates(this.data.protocol, this.data.data, this.translate, r.methodology);
				protocolGeneral.objective = ProtocolUtils.getObjectiveTestQualificates(this.data.protocol, this.data.data, this.translate, r.objective);
				protocolGeneral.criteria = ProtocolUtils.getCriteriaTestQualificates(this.data.protocol, this.data.data, this.translate, r.criteria);
				this.dataSource?.protocolQTestGeneralData.push(protocolGeneral)
			});
		});
	} 

	refreshCriteria(): void {
		this.spinnerService.show();
		this.testGeneralDataConfigService.getTestGeneralDataConfigById(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((result: TestGeneralDataConfig[]) => {
			result?.forEach(r => {
				this.dataSource.protocolQTestGeneralData.forEach(e => {
					e.criteria = ProtocolUtils.getCriteriaTestQualificates(this.data.protocol, this.data.data, this.translate, r.criteria);
				})
			});
			this.spinnerService.hide();
		}, error => {
			this.spinnerService.hide();

		});
	}

	refreshMethodology(): void {
		this.spinnerService.show();
		this.testGeneralDataConfigService.getTestGeneralDataConfigById(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((result: TestGeneralDataConfig[]) => {
			result?.forEach(r => {
				this.dataSource.protocolQTestGeneralData.forEach(e => {
					e.methodology = ProtocolUtils.getMethodologyTestQualificates(this.data.protocol, this.data.data, this.translate, r.methodology);
				})
			});
			this.spinnerService.hide();
		}, error => {
			this.spinnerService.hide();
		});
	}

	refreshObjetive(): void {
		this.spinnerService.show();
		this.testGeneralDataConfigService.getTestGeneralDataConfigById(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((result: TestGeneralDataConfig[]) => {
			result?.forEach(r => {
				this.dataSource.protocolQTestGeneralData.forEach(e => {
					e.objective = ProtocolUtils.getObjectiveTestQualificates(this.data.protocol, this.data.data, this.translate, r.objective);
				})
			});
			this.spinnerService.hide();
		}, error => {
			this.spinnerService.hide();
		});
	}

	onChangeSelectionOption(): void {
		this.displayedColumns = [];
		this.displayedColumns.push('verificationTypeDesc');
		if (this.testConfig.expectedResult) {
			this.displayedColumns.push('expectedResult')
		}

		if (this.testConfig.obtainedResult) {
			this.displayedColumns.push('obtainedResult')
		}

		if (this.testConfig.testResult) {
			this.displayedColumns.push('testResult')
		}

		this.columnsToDisplay = this.displayedColumns.slice();
	}

	deleteRowItemVerification(indexGroup: number, indexItem: number, itemData: number): void {
		if (this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem]) {
			this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification.splice(itemData, 1)
		}
	}

	deleteRowData(indexGroup: number, indexItem: number, itemValue: number, itemData: number): void {
		if (this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem]) {
			this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[itemValue].protocolQTestDataMultiple.splice(itemData, 1)
		}
	}


	addRowData(indexGroup: number, indexItem: number, itemValue: number): void {
		if (this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem]) {
			if (this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[itemValue]) {
				if (!this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[itemValue].protocolQTestDataMultiple) {
					this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[itemValue].protocolQTestDataMultiple = [];
				}

				let dataMultiple = new ProtocolQTestData();
				this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[itemValue].protocolQTestDataMultiple.push(dataMultiple);
			}
		}
	}

	deleteRowItem(indexGroup: number, indexItem: number): void {
		const message = this.translate.instant('test.delete.item.confirm');
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
			if (result === true) {
				this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems.splice(indexItem, 1)
			}
		});
	}

	onOkClick(): void {
		const errs = [];

		if (this.testConfig.expectedResult) {
			if (this.dataSource.protocolQTestItemGroup != null) {
				for (let index = 0; index < this.dataSource.protocolQTestItemGroup.length; index++) {
					const element = this.dataSource.protocolQTestItemGroup[index];

					if (!element.protocolQTestItems) {
						errs.push(this.translate.instant('protocolTest.probe.add.error'));
					} else {
						// eslint-disable-next-line @typescript-eslint/prefer-for-of, @typescript-eslint/no-unsafe-member-access
						for (let index = 0; index < element.protocolQTestItems.length; index++) {
							const elementItem = element.protocolQTestItems[index];
							if (!elementItem && this.testConfig.item) {
								errs.push(this.translate.instant('protocolTest.verificationType.item.description.error'));
							} else {
								if (!elementItem.description) {
									errs.push(this.translate.instant('protocolTest.verificationType.item.error'));
								}
								// eslint-disable-next-line @typescript-eslint/prefer-for-of, max-len
								for (let indexItemValue = 0; indexItemValue < elementItem.protocolQTestItemVerification?.length; indexItemValue++) {
									const elementItemVerification = elementItem.protocolQTestItemVerification[indexItemValue];
									if (!elementItemVerification) {
										errs.push(this.translate.instant('protocolTest.verificationType.add.error'));
									} else {
										if (!elementItemVerification.verification) {
											errs.push(this.translate.instant('protocolTest.verificationType.descripction.error'));
										}
		
										for (let indexData = 0; indexData < elementItemVerification.protocolQTestDataMultiple?.length; indexData++) {
											const elementMultiple = elementItemVerification.protocolQTestDataMultiple[indexData];
											if (!elementMultiple) {
												errs.push(this.translate.instant('protocolTest.verificationType.add.error'));
											} else {
												/*if (!elementMultiple.expectedResultDesc) {
													errs.push(this.translate.instant('protocolTest.verificationType.expectedResultDesc.error'));
												}*/
												
												// eslint-disable-next-line max-len
												if (!elementMultiple.resultDesc || elementMultiple.resultDesc?.length === 0) {
													errs.push(this.translate.instant('protocolTest.verificationType.resultDesc.error'));
												}
											}
										}
									}
								}
							}
						}
					}
					
				}
			}
		}

		/*if (this.testConfig.testResult) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			if (!this.dataSource.protocolQTestResults || this.dataSource.protocolQTestResults.length === 0) {
				errs.push(this.translate.instant('protocolTest.probe.add.error'));
			} else {
				// eslint-disable-next-line @typescript-eslint/prefer-for-of, @typescript-eslint/no-unsafe-member-access
				for (let index = 0; index < this.dataSource.protocolQTestResults.length; index++) {
					if (!this.dataSource.protocolQTestResults[index].resultExpected) {
						errs.push(this.translate.instant('protocolTest.test.result.resultExpected.error'));
					} else {
						const valueTestData = this.dataSource.protocolQTestResults[index].resultExpected?.filter(e => e === '');
						if (valueTestData != null && valueTestData?.length > 0) {
							errs.push(this.translate.instant('protocolTest.verificationType.expectedResultDesc.error'));
						}
					}
					if (!this.dataSource.protocolQTestResults[index].result || this.dataSource.protocolQTestResults[index].result?.length === 0) {
						errs.push(this.translate.instant('protocolTest.test.result.result.error'));
					}
					if (!this.dataSource.protocolQTestResults[index].verification) {
						errs.push(this.translate.instant('protocolTest.test.result.verification.error'));
					}
				}
			}
		}*/

		if (this.testConfig.testVerification) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			if (this.dataSource.protocolQTestVerification && this.dataSource.protocolQTestVerification.length > 0) {
				for (let index = 0; index < this.dataSource.protocolQTestVerification.length; index++) {
					if (!this.dataSource.protocolQTestVerification[index].test) {
						errs.push(this.translate.instant('protocolTest.testVerification.test.error'));
					}
					if (!this.dataSource.protocolQTestVerification[index].descriptionTest) {
						errs.push(this.translate.instant('protocolTest.testVerification.description.test.error'));
					}
					if (!this.dataSource.protocolQTestVerification[index].resultDesc || this.dataSource.protocolQTestVerification[index].resultDesc?.length === 0) {
						errs.push(this.translate.instant('protocolTest.testVerification.result.error'));
					}
				}

			}
		}

		if (errs.length === 0) {
			if (!this.dataSource.regUser) {
				this.dataSource.regUser = this.currentUser.username;
				this.dataSource.regDate = new Date();
			}

			this.dataSource.modUser = this.currentUser.username;
			this.dataSource.modDate = new Date();

			if (this.data.idStatus === ProtocolStatus.FIRMADO) {

				this.requestReason((reason) => {
					this.dataSource.reason = reason;

					this.dataSource.reason = this.data.reason;
					this.dialogRef.close(this.dataSource);
				});
			} else {
				this.dialogRef.close(this.dataSource);
			}

		} else {
			const error = errs.join('\n');
			this.snackBarService.sendError(error);
		}
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	newItemVeritication(indexGroup: number): void {
		const protocolQTestItem = new ProtocolQTestItem();
		protocolQTestItem.idType = this.data.testQType.id;
		this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems.push(protocolQTestItem);
	}

	newItemVerification(indexGroup: number, index: number): void {

		if (!this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[index].protocolQTestItemVerification) {
			this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[index].protocolQTestItemVerification = [];
		}

		const protocolQTestData = new ProtocolQTestItemVerification();

		const protocolQTestMultiple = new ProtocolQTestData();
		protocolQTestMultiple.resultDesc = [];
		protocolQTestData.protocolQTestDataMultiple = [];
		protocolQTestData.protocolQTestDataMultiple.push(protocolQTestMultiple);

		this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[index].protocolQTestItemVerification.push(protocolQTestData);

	}

	newDataVerification(indexGroup: number, indexItem: number, indexVerification: number): void {

		if (!this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[indexVerification].protocolQTestDataMultiple) {
			this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[indexVerification].protocolQTestDataMultiple = [];
		}

		const protocolQTestData = new ProtocolQTestData();
		protocolQTestData.resultDesc = [];
		this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[indexVerification].protocolQTestDataMultiple.push(protocolQTestData);

	}

	newProbeTraceability(): void {

		if (!this.dataSource.protocolQTestProbeTraceability) {
			this.dataSource.protocolQTestProbeTraceability = [];
		}
		const probe = new ProtocolQTestProbeTraceability();
		this.dataSource.protocolQTestProbeTraceability.push(probe);
	}


	deleteProbeTraceability(itemData: number): void {
		this.dataSource.protocolQTestProbeTraceability.splice(itemData, 1)
	}

	newDataResult(): void {
		const protocolResult = new ProtocolQTestResults();
		if (!this.dataSource?.protocolQTestResults) {
			this.dataSource.protocolQTestResults = [];
		}
		protocolResult.resultExpected = [];
		protocolResult.resultExpected.push('');
		this.dataSource.protocolQTestResults.push(protocolResult);
	}

	deleteRowDataResult(itemData: number): void {
		this.dataSource.protocolQTestResults.splice(itemData, 1)
	}

	newBioTraceability(): void {
		if (!this.dataSource.protocolQTestBioindicadores) {
			this.dataSource.protocolQTestBioindicadores = [];
		}
		const bio = new ProtocolQTestBioindicadores();
		bio.protocolTestId = this.data.testQType.id;
		this.dataSource.protocolQTestBioindicadores.push(bio);
	}

	deleteBioTraceability(itemData: number): void {
		this.dataSource.protocolQTestBioindicadores.splice(itemData, 1)
	}

	newTestVerification(): void {
		if (!this.dataSource.protocolQTestVerification) {
			this.dataSource.protocolQTestVerification = [];
		}
		const test = new ProtocolQTestDataOQ();
		test.idProtocol = this.data.testQType.id;
		this.dataSource.protocolQTestVerification.push(test);

	}
	deleteTestVerification(itemData: number): void {
		this.dataSource.protocolQTestVerification.splice(itemData, 1)
	}

	private requestReason(callback: (reason: string) => void) {
		const dialogRef = this.dialog.open(ReasonDialogComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
			if (result != null) {
				callback(result);
			}
		});
	}

	onImageSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		if (!input.files?.length) {
			return;
		}

		const file = input.files[0];
		this.fileName = file.name;

		const reader = new FileReader();

		reader.onload = () => {
			const base64String = reader.result as string;
			// Remover la parte "data:image/jpeg;base64,"
			const base64WithoutPrefix = base64String.split(',')[1];
			this.dataSource.imageTest = base64WithoutPrefix;
			console.log('Image in base64 without prefix:', this.dataSource.imageTest);
		};

		reader.readAsDataURL(file);
	}

	openVisualizerImage(verificationData: ProtocolQTestItemVerification): void {
		this.spinnerService.show();
		
		if (verificationData.idImage) {
			this.attachmentService.getImageToVerification(verificationData.id).pipe(takeUntil(this.destroy$)).subscribe((result: FileInfo) => {
				let src: string;
				if (result) {
					src = result.contentString;
					this.dialogVisualizerImage(src, verificationData);
					this.spinnerService.hide();
				} else {
					this.dialogVisualizerImage(null, verificationData);
					this.spinnerService.hide();
				}
			});
		} else {
			this.dialogVisualizerImage(null, verificationData);
			this.spinnerService.hide();
		}
	}

	openVisualizerImageMultiple(data: ProtocolQTestData): void {
		this.spinnerService.show();
		
		if (data.idImage && !data.dataImage) {
			this.attachmentService.getImageToDataMultiple(data.idImage).pipe(takeUntil(this.destroy$)).subscribe((result: FileInfo) => {
				let src: string;
				if (result) {
					src = result.contentString;
					this.dialogVisualizerImageMultiple(src, data);
					this.spinnerService.hide();
				} else {
					if (data.dataImage) {
						void FileUtils.toBase64(data.dataImage).then((res: string) => {
							this.dialogVisualizerImageMultiple(res, data);
						});
					} else {
						this.dialogVisualizerImageMultiple(null, data);
					}
					this.spinnerService.hide();
				}
			}, error => {
				this.spinnerService.hide();
				console.log(error);
			});
		} else {
			this.dialogVisualizerImageMultiple(null, data);
			this.spinnerService.hide();
		}
	}

	dialogVisualizerImage(src: string, verificationData: ProtocolQTestItemVerification): void {
		const dialogRef = this.dialog.open(ResizeImageComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				src: src
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
			if (result) {
				this.spinnerService.show();

				// Verificar si width y height están definidos
				if (result.width != null && result.height != null) {
					this.attachmentService.uploadImageToVerificationWithXY(
						verificationData.id,
						this.data.protocol.id,
						this.data.data.id, 
						result.file, 
						result.width, 
						result.height
					).pipe(takeUntil(this.destroy$)).subscribe((result: number) => {
						this.spinnerService.hide();
						verificationData.idImage = result;
						this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.attachments.dialog.form.upload.ok') as string);
					}, () => {
						this.spinnerService.hide();
						this.snackBarService.sendError(this.translate.instant('protocolEdit.attachments.dialog.form.upload.error.generic') as string);
					});
				} else {
					// Llamar a otra función sin width y height
					this.attachmentService.uploadImageToVerification(
						verificationData.id,
						this.data.protocol.id,
						this.data.data.id,
						result.file
					).pipe(takeUntil(this.destroy$)).subscribe((result: number) => {
						this.spinnerService.hide();
						verificationData.idImage = result;
						this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.attachments.dialog.form.upload.ok') as string);
					}, () => {
						this.spinnerService.hide();
						this.snackBarService.sendError(this.translate.instant('protocolEdit.attachments.dialog.form.upload.error.generic') as string);
					});
				}
			}
		});
	}

	dialogVisualizerImageMultiple(src: string, data: ProtocolQTestData): void {
		const dialogRef = this.dialog.open(ResizeImageComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				src: src
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: DataResultResizeImage) => {
			if (result) {
				if (!data.id) {
					data.dataImage = result.file;
				} else {
					// Verificar si width y height están definidos
				if (result.width != null && result.height != null) {
					this.attachmentService.uploadImageToDataMultipleWithXY(
						data.id,
						this.data.protocol.id,
						this.data.data.id, 
						data.idVerification,
						result.file, 
						result.width, 
						result.height
					).pipe(takeUntil(this.destroy$)).subscribe((result: number) => {
						this.spinnerService.hide();
						data.idImage = result;
						this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.attachments.dialog.form.upload.ok') as string);
					}, () => {
						this.spinnerService.hide();
						this.snackBarService.sendError(this.translate.instant('protocolEdit.attachments.dialog.form.upload.error.generic') as string);
					});
				} else {
					// Llamar a otra función sin width y height
					this.attachmentService.uploadImageToDataMultiple(
						data.id,
						this.data.data.id,
						this.data.protocol.id,
						data.idVerification,
						result.file,
					
					).pipe(takeUntil(this.destroy$)).subscribe((result: number) => {
						this.spinnerService.hide();
						data.idImage = result;
						this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.attachments.dialog.form.upload.ok') as string);
					}, () => {
						this.spinnerService.hide();
						this.snackBarService.sendError(this.translate.instant('protocolEdit.attachments.dialog.form.upload.error.generic') as string);
					});
				}
				}
			}
		});
	}

	drop(event: CdkDragDrop<any[]>, indexGroup: number, indexItem: number) {
		if (event.previousIndex !== event.currentIndex) {
		  const item = this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem];
	  	  const movedItem = event.item.data;
	  
		  item.protocolQTestItemVerification.splice(event.previousIndex, 1);
		  item.protocolQTestItemVerification.splice(event.currentIndex, 0, movedItem);
		  item.protocolQTestItemVerification.forEach((element, index) => {
			element.order = index + 1;
		  });

		  this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem] = { ...item };

		  this.cdr.detectChanges();
		}
	}

	trackByFn(index: number, item: any): number {
		return item.id || index;
	}

	showLastTacometer(index: number) {
		return this.dataSource?.protocolQTestProbeTraceability?.length === index + 1;
	}

	newEssayOpenDialog(): void {
		const dialogRef = this.dialog.open(ProtocolQEditTestEssayComponent, {
			minWidth: '90vw',
			height: '95vh',
			data: {
				essay: new ProtocolQTestEssayGroup(),
				isEdit: false,
				idProtocolTest: this.dataSource.id,
				idTestType: this.data.testQType.id,
				disabled: false
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ProtocolQTestEssayGroup) => {
			if (result != null) {
				this.spinnerService.show();
				
				let itemGroups = [];
				if (!this.dataSource.protocolQTestEssayGroup) {
					this.dataSource.protocolQTestEssayGroup = [];
				}
				this.dataSource.protocolQTestEssayGroup.push(result);

				const numCycle = ProtocolUtils.getCycleFields(result);

				for (let index = 0; index < numCycle; index++) {
					let group = new ProtocolQTestItemGroup();
					group.numCycle = index + 1;
					group.idTestType = this.data.testQType.id;
					group.active = true;
					group.title = result.title;
					group.translationType = result.translationType;
					group.uuid = result.uuid;
					group.idEssayType = result.idType;
					itemGroups.push(group);
					this.testQItemService.findAllByIdTest(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((resultItem: TestQItem[]) => {
						if (resultItem != null) {
							for (let indexTest= 0; indexTest < resultItem.length; indexTest++) {
								const element = resultItem[indexTest];
								
								const protocolQTestItem = new ProtocolQTestItem();
								protocolQTestItem.description = element.description;
								protocolQTestItem.idType = element.idType;
								protocolQTestItem.protocolQTestItemVerification = [];
								element.testQItemVerifications?.forEach(rt => {
									const protocolQTestItemVerification = new ProtocolQTestItemVerification();
									if (this.data.testQType.id === TestTypeEnum.VERIFICATION_APPROVAL_PROTOCOL_QUALIFICATION) {
										if (rt.verification === 'PRIQOQPQQXXXX') {
											protocolQTestItemVerification.verification = this.data.nProtocol;
										} else {
											protocolQTestItemVerification.verification = rt.verification;
										}
									} else {
										protocolQTestItemVerification.verification = rt.verification;
									}

									rt.testQDataMultiple.forEach(pte => {
										const protocolQTestData = new ProtocolQTestData();
										protocolQTestData.expectedResultRhDesc = pte.expectedResultRhDesc;
										if (this.data.testQType.id === TestTypeEnum.EQUIPMENT_VERIFICATION) {
											if (pte.expectedResultRhDesc) {
												protocolQTestData.expectedResultDesc =  ProtocolUtils.getEquipmentByField(pte.expectedResultRhDesc, this.data.equipment);
											}
										} else {
											protocolQTestData.expectedResultDesc = pte.expectedResultDesc;
										}
										protocolQTestData.resultDesc = pte.resultDesc;
										protocolQTestData.onlyLine = pte.combined;
										protocolQTestData.uuid =  result.uuid;
										if (!protocolQTestItemVerification.protocolQTestDataMultiple) {
											protocolQTestItemVerification.protocolQTestDataMultiple = [];
										}
										protocolQTestItemVerification.protocolQTestDataMultiple.push(protocolQTestData);
									});
	
									protocolQTestItem.protocolQTestItemVerification.push(protocolQTestItemVerification);
								});
			
								if (!itemGroups[index].protocolQTestItems) {
									itemGroups[index].protocolQTestItems = [];
								}

								const hasBio = result.essayValues?.some(value => value.sensors?.some(sensor => sensor.hasBioindicator));
								if (hasBio) {
									const itemVerificationBio = new ProtocolQTestItemVerification();
									itemVerificationBio.verification = this.translate.instant('test.verification.bios');
									itemVerificationBio.processingType = VerificationProcessingTypeEnum.BIOINDICATOR;
									itemVerificationBio.protocolQTestDataMultiple = [];
									const dataBio = new ProtocolQTestData();
									dataBio.onlyLine = false;
									dataBio.expectedResultDesc = this.translate.instant('common.yes');
									dataBio.resultDesc = ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
									itemVerificationBio.order = protocolQTestItem.protocolQTestItemVerification != null ? protocolQTestItem.protocolQTestItemVerification.length + 1 : 1;
									dataBio.uuid = result.uuid;
									itemVerificationBio.protocolQTestDataMultiple.push(dataBio);

									protocolQTestItem.protocolQTestItemVerification.push(itemVerificationBio);
								} else {
									const hasItemBio = protocolQTestItem.protocolQTestItemVerification.some(iv => iv.processingType === VerificationProcessingTypeEnum.BIOINDICATOR);
									if (hasItemBio) {
										protocolQTestItem.protocolQTestItemVerification = protocolQTestItem.protocolQTestItemVerification.filter(iv => iv.processingType !== VerificationProcessingTypeEnum.BIOINDICATOR);
									}
								}

								itemGroups[index].protocolQTestItems.push(protocolQTestItem);
							}
						}
					});
				}

				if (!this.dataSource.protocolQTestItemGroup) {
					this.dataSource.protocolQTestItemGroup = [];
				}

				for (let indexItem = 0; indexItem < itemGroups.length; indexItem++) {
					const element = itemGroups[indexItem];
					this.dataSource.protocolQTestItemGroup.push(element);
				}
				this.spinnerService.hide();
				this.onEssayTabChange(0);

				if (this.essaysTable) {
					this.essaysTable.renderRows();
				}
				this.configTemplate();
			} else {
				this.spinnerService.hide();
			}
		});
	}

	editEssayOpenDialog(idx: number): void {

		const essay = this.dataSource.protocolQTestEssayGroup[idx];

		const dialogRef = this.dialog.open(ProtocolQEditTestEssayComponent, {
			minWidth: '90vw',
			height: '95vh',
			data: {
				essay: _.cloneDeep(essay),
				isEdit: true,
				idProtocolTest: this.dataSource.id,
				idTestType: this.data.testQType.id,
				disabled: false
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ProtocolQTestEssayGroup) => {
			if (result != null) {
				this.dataSource.protocolQTestEssayGroup[idx] = result;
				const numCycle = ProtocolUtils.getCycleFields(result);
				let resEssays = this.dataSource.protocolQTestItemGroup.filter(e => e.uuid === result.uuid);
				if (resEssays.length != numCycle) {
					if (resEssays.length > numCycle) {
						const res = resEssays.length - numCycle;
						const filteredItems = this.dataSource.protocolQTestItemGroup.filter(e => e.uuid !== result.uuid);

						resEssays = resEssays.splice(res, numCycle);

						this.dataSource.protocolQTestItemGroup = filteredItems;

						if (!this.dataSource.protocolQTestItemGroup) {
							this.dataSource.protocolQTestItemGroup = [];
						}

						for (let index = 0; index < resEssays.length; index++) {
							const element = resEssays[index];
							element.numCycle = index + 1;
							this.dataSource.protocolQTestItemGroup.push(element);
						}

					} else {
						this.testQItemService.findAllByIdTest(this.data.testQType.id).pipe(takeUntil(this.destroy$)).subscribe((resultConfig: TestQItem[]) => {
							if (resultConfig != null) {
								const res = numCycle - resEssays?.length;
								for (let index = 0; index < res; index++) {
									const countEssay = this.dataSource.protocolQTestItemGroup.filter(e => e.uuid === result.uuid);
									let itemGroup = new ProtocolQTestItemGroup();
									itemGroup.numCycle = countEssay.length + 1;
									itemGroup.idTestType = this.data.testQType.id;
									itemGroup.active = true;
									itemGroup.title = result.title;
									itemGroup.translationType = result.translationType;
									itemGroup.uuid = result.uuid;
									itemGroup.idEssayType = result.idType;
									itemGroup.position = result.position;
									if (result.idType == EssayTypeEnum.ENSAYO_APERTURA_DE_PUERTA) {
										const protocolQTestItem = new ProtocolQTestItem();
										protocolQTestItem.description = 'N/A'
										protocolQTestItem.idType = 19;
										protocolQTestItem.protocolQTestItemVerification = [];

										const protocolQTestItemVerification = new ProtocolQTestItemVerification();
										protocolQTestItemVerification.verification = this.translate.instant('protocolEdit.test.verification.essayCorrect');
										protocolQTestItemVerification.processingType = VerificationProcessingTypeEnum.PROBES_CORRECTLY;
										const protocolQTestData = new ProtocolQTestData();
										protocolQTestData.expectedResultDesc = this.translate.instant('common.yes');
										protocolQTestData.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
										protocolQTestItemVerification.protocolQTestDataMultiple = [];
										protocolQTestItemVerification.protocolQTestDataMultiple.push(protocolQTestData);

										protocolQTestItem.protocolQTestItemVerification.push(protocolQTestItemVerification);
										
										const itemVerificationTwo = new ProtocolQTestItemVerification();
										itemVerificationTwo.verification = this.translate.instant('protocolEdit.test.verification.openDoor');
										protocolQTestItemVerification.processingType = VerificationProcessingTypeEnum.COMPLETY_OPEN_DOOR;
										const dataMultipleTwo = new ProtocolQTestData();
										dataMultipleTwo.expectedResultDesc = this.translate.instant('common.yes');
										dataMultipleTwo.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
										itemVerificationTwo.protocolQTestDataMultiple = [];
										itemVerificationTwo.protocolQTestDataMultiple.push(dataMultipleTwo);

										protocolQTestItem.protocolQTestItemVerification.push(itemVerificationTwo);

										if (!itemGroup.protocolQTestItems) {
											itemGroup.protocolQTestItems = [];
										}
		
										itemGroup.protocolQTestItems.push(protocolQTestItem);
									} else if (result.idType == EssayTypeEnum.ENSAYO_CORTE_ELECTRICO) {
										const protocolQTestItem = new ProtocolQTestItem();
										protocolQTestItem.description = 'N/A'
										protocolQTestItem.idType = 19;
										protocolQTestItem.protocolQTestItemVerification = [];

										const protocolQTestItemVerification = new ProtocolQTestItemVerification();
										protocolQTestItemVerification.verification = this.translate.instant('protocolEdit.test.verification.essayCorrect');
										protocolQTestItemVerification.processingType = VerificationProcessingTypeEnum.PROBES_CORRECTLY;
										const protocolQTestData = new ProtocolQTestData();
										protocolQTestData.expectedResultDesc = this.translate.instant('common.yes');
										protocolQTestData.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
										protocolQTestItemVerification.protocolQTestDataMultiple = [];
										protocolQTestItemVerification.protocolQTestDataMultiple.push(protocolQTestData);

										protocolQTestItem.protocolQTestItemVerification.push(protocolQTestItemVerification);
										
										const itemVerificationTwo = new ProtocolQTestItemVerification();
										itemVerificationTwo.verification = this.translate.instant('protocolEdit.test.verification.cutElectric');
										itemVerificationTwo.processingType = VerificationProcessingTypeEnum.COMPLETY_CUT_ELECTRIC;
										const dataMultipleOpenTwo = new ProtocolQTestData();
										dataMultipleOpenTwo.expectedResultDesc = this.translate.instant('common.yes');
										dataMultipleOpenTwo.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
										itemVerificationTwo.protocolQTestDataMultiple = [];
										itemVerificationTwo.protocolQTestDataMultiple.push(dataMultipleOpenTwo);

										protocolQTestItem.protocolQTestItemVerification.push(itemVerificationTwo);
										
										if (!itemGroup.protocolQTestItems) {
											itemGroup.protocolQTestItems = [];
										}

										itemGroup.protocolQTestItems.push(protocolQTestItem);
									} else if (result.idType === EssayTypeEnum.CICLO_SIP_CICLO_ESTERILIZACION_FILTRO || result.idType === EssayTypeEnum.PENETRACION_CON_CARGA) {
										const protocolQTestItem = new ProtocolQTestItem();
										protocolQTestItem.description = 'N/A'
										protocolQTestItem.idType = 19;
										protocolQTestItem.protocolQTestItemVerification = [];

										const protocolQTestItemVerification = new ProtocolQTestItemVerification();
										protocolQTestItemVerification.verification = this.translate.instant('protocolEdit.test.verification.essayCorrect');
										protocolQTestItemVerification.processingType = VerificationProcessingTypeEnum.PROBES_CORRECTLY;
										const protocolQTestData = new ProtocolQTestData();
										protocolQTestData.expectedResultDesc = this.translate.instant('common.yes');
										protocolQTestData.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
										protocolQTestItemVerification.protocolQTestDataMultiple = [];
										protocolQTestItemVerification.protocolQTestDataMultiple.push(protocolQTestData);
										protocolQTestItem.protocolQTestItemVerification.push(protocolQTestItemVerification);
										
										const itemVerificationTwo = new ProtocolQTestItemVerification();
										itemVerificationTwo.verification = this.translate.instant('protocolEdit.test.verification.criteria');
										itemVerificationTwo.processingType = VerificationProcessingTypeEnum.MEETS_CRITERIA;
										const dataMultipleOpenTwo = new ProtocolQTestData();
										dataMultipleOpenTwo.expectedResultDesc = this.translate.instant('common.yes');
										dataMultipleOpenTwo.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
										itemVerificationTwo.protocolQTestDataMultiple = [];
										itemVerificationTwo.protocolQTestDataMultiple.push(dataMultipleOpenTwo);
										protocolQTestItem.protocolQTestItemVerification.push(itemVerificationTwo);

										const hasBio = result.essayValues?.some(value => value.sensors?.some(sensor => sensor.hasBioindicator));
										if (hasBio) {
											const itemVerificationCriteria = new ProtocolQTestItemVerification();
											itemVerificationCriteria.verification = this.translate.instant('protocolEdit.test.verification.bioindicador');
											itemVerificationCriteria.processingType = VerificationProcessingTypeEnum.BIOINDICATOR;
											const dataMultipleCriteria = new ProtocolQTestData();
											dataMultipleCriteria.expectedResultDesc = this.translate.instant('common.yes');
											dataMultipleCriteria.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
											itemVerificationCriteria.protocolQTestDataMultiple = [];
											itemVerificationCriteria.protocolQTestDataMultiple.push(dataMultipleCriteria);
											protocolQTestItem.protocolQTestItemVerification.push(itemVerificationCriteria);
										}

										const hasEndotoxin = result.essayValues?.some(value => value.sensors?.some(sensor => sensor.hasEndotoxin));
										if (hasEndotoxin) {
											const itemVerificationCriteria = new ProtocolQTestItemVerification();
											itemVerificationCriteria.verification = this.translate.instant('protocolEdit.test.verification.endotoxin');
											itemVerificationCriteria.processingType = VerificationProcessingTypeEnum.ENDOTOXIN;
											const dataMultipleCriteria = new ProtocolQTestData();
											dataMultipleCriteria.expectedResultDesc = this.translate.instant('common.yes');
											dataMultipleCriteria.resultDesc =  ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
											itemVerificationCriteria.protocolQTestDataMultiple = [];
											itemVerificationCriteria.protocolQTestDataMultiple.push(dataMultipleCriteria);
											protocolQTestItem.protocolQTestItemVerification.push(itemVerificationCriteria);
										}
										
										if (!itemGroup.protocolQTestItems) {
											itemGroup.protocolQTestItems = [];
										}

										itemGroup.protocolQTestItems.push(protocolQTestItem);
									} else {
										for (let indexTest= 0; indexTest < resultConfig.length; indexTest++) {
											const element = resultConfig[indexTest];
											
											const protocolQTestItem = new ProtocolQTestItem();
											protocolQTestItem.description = element.description;
											protocolQTestItem.idType = element.idType;
											protocolQTestItem.protocolQTestItemVerification = [];
											element.testQItemVerifications?.forEach(rt => {
												const protocolQTestItemVerification = new ProtocolQTestItemVerification();
												if (this.data.testQType.id === TestTypeEnum.VERIFICATION_APPROVAL_PROTOCOL_QUALIFICATION) {
													if (rt.verification === 'PRIQOQPQQXXXX') {
														protocolQTestItemVerification.verification = this.data.nProtocol;
													} else {
														protocolQTestItemVerification.verification = rt.verification;
													}
												} else {
													protocolQTestItemVerification.verification = rt.verification;
												}
			
												rt.testQDataMultiple.forEach(pte => {
													const protocolQTestData = new ProtocolQTestData();
													protocolQTestData.expectedResultRhDesc = pte.expectedResultRhDesc;
													if (this.data.testQType.id === TestTypeEnum.EQUIPMENT_VERIFICATION) {
														if (pte.expectedResultRhDesc) {
															protocolQTestData.expectedResultDesc =  ProtocolUtils.getEquipmentByField(pte.expectedResultRhDesc, this.data.equipment);
														}
													} else {
														protocolQTestData.expectedResultDesc = pte.expectedResultDesc;
													}
													protocolQTestData.resultDesc = pte.resultDesc;
													if (!protocolQTestItemVerification.protocolQTestDataMultiple) {
														protocolQTestItemVerification.protocolQTestDataMultiple = [];
													}
													protocolQTestItemVerification.protocolQTestDataMultiple.push(protocolQTestData);
												});
				
												protocolQTestItem.protocolQTestItemVerification.push(protocolQTestItemVerification);
											});
						
											if (!itemGroup.protocolQTestItems) {
												itemGroup.protocolQTestItems = [];
											}
											itemGroup.protocolQTestItems.push(protocolQTestItem);
										}
									}
									this.dataSource.protocolQTestItemGroup.push(itemGroup);
								}
								resEssays?.forEach(e => {
									e.title = result.title;
									e.idEssayType = result.idType;
								});
							}

							for (let indexAutIndex = 0; indexAutIndex < this.dataSource.protocolQTestItemGroup.length; indexAutIndex++) {
								const elementAut = this.dataSource.protocolQTestItemGroup[indexAutIndex];
								
								const existsVBios = elementAut?.protocolQTestItems?.some(gqp => gqp.protocolQTestItemVerification.some(piv => piv.processingType === VerificationProcessingTypeEnum.BIOINDICATOR));
								if (existsVBios) {
									const hasBio = result.essayValues?.some(value => value.sensors?.some(sensor => sensor.hasBioindicator));
									if (hasBio) {
										const itemVerificationBio = new ProtocolQTestItemVerification();
										itemVerificationBio.verification = this.translate.instant('test.verification.bios');
										itemVerificationBio.processingType = VerificationProcessingTypeEnum.BIOINDICATOR;
										itemVerificationBio.order = this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems[0].protocolQTestItemVerification != null ? this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems[0].protocolQTestItemVerification.length + 1 : 1;
										itemVerificationBio.protocolQTestDataMultiple = [];
										
										const dataBio = new ProtocolQTestData();
										dataBio.onlyLine = false;
										dataBio.expectedResultDesc = this.translate.instant('common.yes');
										dataBio.resultDesc = ArrayUtils.toStringArray(this.translate.instant('test.verification.result'));
										dataBio.uuid = result.uuid;
										itemVerificationBio.protocolQTestDataMultiple.push(dataBio);
			
										if (this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems[0]) {
											this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems[0].protocolQTestItemVerification.push(itemVerificationBio);
										}
									}
								} else {
									for (let indexItemGroup = 0; indexItemGroup < this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems.length; indexItemGroup++) {
										const elementItemGroup = this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems[indexItemGroup];
			
										const hasItemBio = elementItemGroup.protocolQTestItemVerification.some(iv => iv.processingType === VerificationProcessingTypeEnum.BIOINDICATOR);						
										if (hasItemBio) {
											this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems[indexItemGroup].protocolQTestItemVerification = this.dataSource.protocolQTestItemGroup[indexAutIndex].protocolQTestItems[indexItemGroup].protocolQTestItemVerification.filter(iv => iv.processingType !== VerificationProcessingTypeEnum.BIOINDICATOR);
										}
									}
			
										
								}
							}			
						});
					}
				}

				if (this.essaysTable) {
					this.essaysTable.renderRows();
				}

				const message = this.translate.instant('test.configTemplate.confirmSave');
				const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

				dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
					if (result === true) {
						this.configTemplate();
					}
				});
			}
		});
	}

	getVariablesFromEssay(essay: ProtocolQTestEssayGroup): string {
		return ProtocolUtils.getVariablesFromEssayQualification(essay, this.translate);
	}

	getCriteriaFromEssay(essay: ProtocolQTestEssayGroup): string {
		if (!essay || !essay.essayValues) {
			return null;
		}

		return essay.essayValues.map(i => EssayUtils.getCriteriasToShowThermal(i, this.translate)).filter(f => f != null).join('; ');
	}

	getLoadFromEssay(essay: ProtocolQTestEssayGroup): string {
		if (!essay || !essay.essayValues) {
			return null;
		}

		const fields = [];
		
		//essay.essayValues.forEach(i => i.fields?.filter(field => field.idField === FieldEnum.LOAD).forEach(field => fields.push(field.value)));

		return essay.load ? essay.load : "-";
	}

	deleteEssayRow(index: number, uuid: string): void {
		if (index > -1) {
			this.dataSource.protocolQTestEssayGroup = this.dataSource.protocolQTestEssayGroup?.filter(e => e.uuid != uuid);

			if (this.essaysTable) {
				this.essaysTable.renderRows();
			}
		}
	}

	showTestEssay(): boolean {
		const allowedTest = [TestTypeEnum.TEST_BOWIE_DICK, TestTypeEnum.TEST_TEMPERATURE_DISTRIBUTION_MOISTURE_CO2_WITH_LOAD_OPENING_DOORS, TestTypeEnum.TEST_TIGHTNESS_TEST_VACUUM_TEST_LEAK_TEST, TestTypeEnum.LEAKAGE_TEST, 
			TestTypeEnum.TEMPERATURE_PENETRATION_TEST_UNDER_LOAD_TEMPERATURE, TestTypeEnum.RELATIVE_MOISTURE_TEMPERATURE_DISTRIBUTION_TEST_CO2_IN_VACUUM];

		if (allowedTest.includes(this.dataSource.idTestType)) {
			return true;
		} else {
			return false;
		}
	}

	isCompletedTest(idTestType: number): boolean {
		const notValidationExpectedResult = [TestTypeEnum.TEST_BOWIE_DICK];
		const notValidationSensor = [TestTypeEnum.TEST_BOWIE_DICK, TestTypeEnum.TEST_TEMPERATURE_DISTRIBUTION_MOISTURE_CO2_WITH_LOAD_OPENING_DOORS, TestTypeEnum.TEST_TIGHTNESS_TEST_VACUUM_TEST_LEAK_TEST, TestTypeEnum.LEAKAGE_TEST, TestTypeEnum.RELATIVE_MOISTURE_TEMPERATURE_DISTRIBUTION_TEST_CO2_IN_VACUUM, TestTypeEnum.TEMPERATURE_PENETRATION_TEST_UNDER_LOAD_TEMPERATURE];
	
		let res = true;
		const testResult = this.data.tests?.find(e => e.idTestType === idTestType);
	 
		if (testResult) {
		  if (testResult.protocolQTestItemGroup?.length > 0) {
			for (let index = 0; index < testResult.protocolQTestItemGroup.length; index++) {
			  const elementGroup = testResult.protocolQTestItemGroup[index];
			  
			  for (let index = 0; index < elementGroup.protocolQTestItems?.length; index++) {
				const element = elementGroup.protocolQTestItems[index];
		
				if (element.protocolQTestItemVerification?.length > 0) {
				  for (let indextiv= 0; indextiv < element.protocolQTestItemVerification?.length; indextiv++) {
					const elementtiv = element.protocolQTestItemVerification[indextiv];
		  
					if (elementtiv.protocolQTestDataMultiple?.length > 0) {
					  for (let indextdm= 0; indextdm < elementtiv.protocolQTestDataMultiple?.length; indextdm++) {
						const elementTDM = elementtiv.protocolQTestDataMultiple[indextdm];
						 if (!notValidationExpectedResult.includes(idTestType)) {
						  if (!elementTDM.expectedResultDesc && !elementTDM.onlyLine) {
							res = false;
						   }
						 }
					   }
					} else {
					  res = false;
					}
				  }
				}
			  } 
			}
		  } else {
			res = false;
		  }
	
		  if (notValidationSensor.includes(idTestType)) {
			if (!testResult.protocolQTestEssayGroup || testResult.protocolQTestEssayGroup?.length === 0) {
			  res = false;
			} 
		  }
		  
		  if (!testResult.protocolQTestGeneralData) {
			res = false;
		  }
		} else {
		  res = false;
		}
	
		return res;
	}

	getCriteriaFromEssayComplete(essay: ProtocolQTestEssayGroup): string {
		if (!essay || !essay.essayValues) {
			return null;
		}

		return essay.essayValues.map(i => EssayUtils.getCriteriasToShowThermal(i, this.translate)).filter(f => f != null).join('\n');
	}

	dropEssay(event: CdkDragDrop<any[]>) {
		if (event.previousIndex !== event.currentIndex) {
			this.dragDisabled = true;

			const item = this.dataSource.protocolQTestEssayGroup;
			moveItemInArray(item, event.previousIndex, event.currentIndex);

			item.forEach((element, index) => {
				element.position = index + 1;
			});

			this.essaysTable.renderRows();

			if (this.dataSource.protocolQTestItemGroup) {
				this.dataSource.protocolQTestEssayGroup.forEach(e => {
					this.dataSource.protocolQTestItemGroup.filter( pt => pt.uuid === e.uuid).forEach(pte => pte.position = e.position);	
				});
			}

			this.dataSource.protocolQTestItemGroup = [...this.dataSource.protocolQTestItemGroup.sort((a, b) => a.position - b.position)];	
			this.cdr.detectChanges();
		}
	}

	isMetodologyEmpty(): boolean {
		return this.dataSource.protocolQTestGeneralData?.some(dg => !dg.methodology || dg.methodology?.trim() != "");
	}

	isObjetiveEmpty(): boolean {
		return this.dataSource.protocolQTestGeneralData?.some(dg => !dg.objective || dg.objective?.trim() != "");
	}

	isCriteriaEmpty(): boolean {
		return this.dataSource.protocolQTestGeneralData?.some(dg => !dg.criteria || dg.criteria?.trim() != "");
	}

	onEssayTabChange(event: MatTabChangeEvent | number): void {
		let groupIndex: number;
	
		if (event instanceof MatTabChangeEvent) {
			groupIndex = event.index;
		} else {
			groupIndex = event;
		}
	
		this._groupItem = groupIndex;
	}

	displayCycle(group: ProtocolQTestItemGroup): boolean {
		return group.numCycle != null && group.translationType != null;
	}

	showButton(): boolean {
		const statusFinalized = [ProtocolStatus.FIRMADO];
	
		return !statusFinalized.includes(this.data.idStatus);
	}

	onChangeOnlyLine(event: MatCheckboxChange, indexGroup: number, indexItem: number, indexVerification: number, indexMultiple: number): void {	
		if (event.checked) {
			const message = this.translate.instant('protocolTest.test.item.onlyLine.info');
			const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });
	
			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
				if (!result) {
					event.checked =false;
					this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[indexVerification].protocolQTestDataMultiple[indexMultiple].onlyLine = false;
				} else {
					this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[indexVerification].protocolQTestDataMultiple[indexMultiple].onlyLine = true;
					this.dataSource.protocolQTestItemGroup[indexGroup].protocolQTestItems[indexItem].protocolQTestItemVerification[indexVerification].protocolQTestDataMultiple[indexMultiple].expectedResultDesc = null;
				}
				this.cdr.detectChanges();
			});
		}
		
	}

	openCreateDialogInstrumentalUsed() {
			const dialogRef = this.dialog.open(ProtocolQEditTestInstrumentalUsedComponent, {
				minWidth: '70%',
				maxHeight: '95vh',
				data: {
					data: new ProtocolQTestInstrumentalUsed(),
					idExecutionTest: this.data.data.id,
					idStatus: this.data.idStatus
				}
			});
	
			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ProtocolQTestInstrumentalUsed) => {
				if (result) {
					if (!this.dataSource.protocolQTestInstrumentalUsed) {
						this.dataSource.protocolQTestInstrumentalUsed = [];
					}
					this.dataSource.protocolQTestInstrumentalUsed.push(result);
					if (this.protocolQTestInstrumentalUsedTable) {
						this.protocolQTestInstrumentalUsedTable.renderRows();
					}
				}
			});
		}
	
		openEditDialogInstrumentalUsed(index: number, item: ProtocolQTestInstrumentalUsed) {
			const dialogRef = this.dialog.open(ProtocolQEditTestInstrumentalUsedComponent, {
				minWidth: '70%',
				maxHeight: '95vh',
				data: {
					data: item,
					isEdit: true,
					idExecutionTest: this.data.data.id,
					idStatus: this.data.idStatus
				}
			});
	
			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ProtocolQTestInstrumentalUsed) => {
				if (result) {
					this.dataSource.protocolQTestInstrumentalUsed[index] = result;
					this.protocolQTestInstrumentalUsedTable.renderRows();
				}
			});
		}
	
		deleteInstrumentalUsed(index: number) {
			this.dataSource.protocolQTestInstrumentalUsed.splice(index, 1);
			this.protocolQTestInstrumentalUsedTable.renderRows();
		}
}